import React from "react"
import styled from "styled-components"
import { breakpoint } from "styles/breakpoints"
import tw from "twin.macro"

export interface TitleProps {
  title: string | undefined
  description: string | undefined
}

export const Container = styled.div`
  ${tw`flex flex-col items-center`}
`

export const Title = styled.h2`
  ${tw`font-condensed text-white text-center`}
  font-size: 56px;
  line-height: 56px;
  ${breakpoint("lg")`
  line-height: inherit;
  `}
`

export const Description = styled.p`
  ${tw`text-center md:w-1/2`}
  font-size: 16px;
`

const DescribedHeading: React.FC<TitleProps> = ({ title, description }) => (
  <Container>
    <Title>{title}</Title>
    <Description>{description}</Description>
  </Container>
)

export default DescribedHeading
